export const categories = [
  {
    id: "variety",
    name: "综艺",
    icon: "ri-live-line",
    desc: "名场面、赛制争议、剪辑逻辑，综艺里的每一次情绪波动都值得复盘。",
    count: 186,
  },
  {
    id: "film",
    name: "影视",
    icon: "ri-film-line",
    desc: "剧集大结局、角色弧光、开放式结尾，追剧之后总要找人聊两句。",
    count: 243,
  },
  {
    id: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    desc: "新歌首发、翻唱对比、舞台改编，耳朵买单之前先来听听大家怎么说。",
    count: 97,
  },
  {
    id: "concert",
    name: "演出",
    icon: "ri-mic-line",
    desc: "演唱会、音乐节、应援文化，现场之外的故事同样热闹。",
    count: 118,
  },
  {
    id: "star",
    name: "明星动态",
    icon: "ri-user-star-line",
    desc: "官宣、回应、工作室声明，看信息如何一步步被拼凑完整。",
    count: 205,
  },
  {
    id: "meme",
    name: "网络热梗",
    icon: "ri-emotion-laugh-line",
    desc: "从一句话到全网模仿，热梗的传播路径比想象中更有意思。",
    count: 164,
  },
  {
    id: "industry",
    name: "行业观察",
    icon: "ri-bar-chart-2-line",
    desc: "短剧、长视频、平台排播，内容行业的每一次转向都牵动观众。",
    count: 76,
  },
];